export class Brod2BeerCalorieTypeValueConverter {
  static x = {
    REGULAR: 'Vanlig',
    LOW_CALORIE: 'Lav-kalori',
  };

  toView(value) {
    return Brod2BeerCalorieTypeValueConverter.toView(value);
  }

  static toView(value) {
    return this.x[value];
  }
}
